import React, { Component } from 'react';
import Slider from '../../common/Slider.js';
import HomepageSlide from './HomepageSlide.js';
import slides from './home-slider.js';

class Home extends Component {
  render() {
    return (
      <Slider length={slides.length} autoSlide={true}>
        {slides.map((slideInfo, i) => 
          <HomepageSlide
            {...slideInfo}
            key={i}
            handleTouchStart={this.props.handleTouchStart}
            handleTouchEnd={this.props.handleTouchEnd}
          />
        )}
      </Slider>
    );
  }
}

export default Home;